module.exports = __webpack_public_path__ + "63f6e5fb0f4ef455fd007d78e58066f4.svg";